import { css } from '@emotion/css';

export const main = css`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
`
